const STORAGE_KEY = 'g360_locale'
const DEFAULT_LOCALE = 'es-MX'

const messages = {
  'es-MX': () => import('./locales/es-MX.json')
}

function normalizeLocale(locale) {
  if (!locale || typeof locale !== 'string') return DEFAULT_LOCALE
  const trimmed = locale.trim()
  if (messages[trimmed]) return trimmed
  const lower = trimmed.toLowerCase()
  if (lower.startsWith('es')) return 'es-MX'
  return DEFAULT_LOCALE
}

function getValue(obj, path) {
  return String(path || '')
    .split('.')
    .reduce((acc, key) => (acc && acc[key] != null ? acc[key] : undefined), obj)
}

const state = {
  locale: DEFAULT_LOCALE,
  catalog: {}
}

async function loadLocaleCatalog(locale) {
  const normalized = normalizeLocale(locale)
  if (!state.catalog[normalized]) {
    const mod = await messages[normalized]()
    state.catalog[normalized] = mod.default || mod
  }
  return state.catalog[normalized]
}

async function setLocale(locale) {
  const normalized = normalizeLocale(locale)
  await loadLocaleCatalog(normalized)
  state.locale = normalized
  localStorage.setItem(STORAGE_KEY, normalized)
  document.documentElement.lang = normalized
  return normalized
}

function t(key, fallback = null) {
  const current = state.catalog[state.locale] || {}
  const value = getValue(current, key)
  return value != null ? value : (fallback ?? key)
}

function getLocale() {
  return state.locale
}

async function initializeI18n() {
  const browserLocale = typeof navigator !== 'undefined' ? navigator.language : DEFAULT_LOCALE
  const storedLocale = localStorage.getItem(STORAGE_KEY)
  await setLocale(storedLocale || browserLocale || DEFAULT_LOCALE)
}

async function setupI18n(app) {
  await initializeI18n()

  const api = {
    t,
    setLocale,
    getLocale
  }

  app.config.globalProperties.$t = t
  app.config.globalProperties.$setLocale = setLocale
  app.config.globalProperties.$getLocale = getLocale

  app.provide('i18n', api)
}

export {
  DEFAULT_LOCALE,
  getLocale,
  initializeI18n,
  normalizeLocale,
  setLocale,
  setupI18n,
  t
}

export default setupI18n
